export type BreadcrumbItem = {
  label: string;
  href?: string;
  onClick?: () => void;
};

const home = { label: "ホーム", href: "/" };
const practice = { label: "練習", href: "/practice" };
const tools = { label: "ツール", href: "/tools" };
const profile = { label: "プロフィール", href: "/account#profile-settings" };
const admin = { label: "運営管理", href: "/admin" };

/** Fallback labels for pages whose breadcrumb does not depend on loaded data. */
export function pageBreadcrumbItems(pathname: string): BreadcrumbItem[] {
  const pages: Record<string, BreadcrumbItem[]> = {
    "/practice": [home, { label: "練習" }],
    "/tools": [home, { label: "ツール" }],
    "/events": [home, { label: "イベント" }],
    "/notifications": [home, { label: "お知らせ" }],
    "/account": [home, { label: "プロフィール" }],
    "/account/profile": [home, profile, { label: "プロフィール設定" }],
    "/account/class": [home, profile, { label: "クラス設定" }],
    "/account/locality": [home, profile, { label: "活動地域設定" }],
    "/stores": [home, { label: "施設" }],
    "/players": [home, { label: "プレイヤー検索" }],
    "/layouts": [home, tools, { label: "テーブル配置図" }],
    "/drills": [home, practice, { label: "ドリル" }],
    "/weaknesses": [home, practice, { label: "弱点" }],
    "/break-speed": [home, tools, { label: "ブレイクスピード" }],
    "/billing": [home, profile, { label: "プランとお支払い" }],
    "/break-speed/purchase": [
      home,
      profile,
      { label: "プランとお支払い", href: "/billing" },
      { label: "ブレイクスピードの購入・無料体験" },
    ],
    "/recruitments": [home, { label: "募集" }],
    "/recruitments/mine": [
      home,
      { label: "募集", href: "/recruitments" },
      { label: "自分の募集・応募" },
    ],
    "/recruitments/new": [
      home,
      { label: "募集", href: "/recruitments" },
      { label: "仲間を募集する" },
    ],
    "/admin/layouts": [admin, { label: "テーブル配置図" }],
    "/admin/audit-logs": [admin, { label: "操作履歴" }],
    "/admin/design-system": [admin, { label: "デザインシステム" }],
  };
  if (pages[pathname]) return pages[pathname];
  if (/^\/billing\/mock\/[^/]+$/.test(pathname))
    return [
      home,
      profile,
      { label: "プランとお支払い", href: "/billing" },
      { label: "仮のお支払い" },
    ];
  const recruitment = pathname.match(/^\/recruitments\/([^/]+)(\/edit)?$/);
  if (recruitment) {
    const items: BreadcrumbItem[] = [
      home,
      { label: "募集", href: "/recruitments" },
      {
        label: "募集の詳細",
        ...(recruitment[2] ? { href: `/recruitments/${recruitment[1]}` } : {}),
      },
    ];
    if (recruitment[2]) items.push({ label: "編集" });
    return items;
  }
  return [];
}
